/**
 * @generated SignedSource<<b701a560ae06b36a3c43c7e9c1c559f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type reviewPage_Query$variables = {
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  perspectiveId?: string | null | undefined;
};
export type reviewPage_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly categories: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly parent: {
      readonly name: string;
    } | null | undefined;
  }>;
  readonly categorizationCoverage: {
    readonly categorizedTxnsCount: number;
    readonly totalTxnsCount: number;
  };
  readonly pendingSuggestions: {
    readonly suggestions: ReadonlyArray<{
      readonly category: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly confidence: number | null | undefined;
      readonly id: string;
      readonly logic: string;
      readonly matchesCount: number;
      readonly origin: string;
      readonly pattern: string;
      readonly rationale: string | null | undefined;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      };
      readonly totalAmount: number;
    }>;
    readonly totalCount: number;
  };
  readonly uncategorizedStakeholders: ReadonlyArray<{
    readonly stakeholder: {
      readonly id: string;
      readonly name: string;
    };
    readonly totalSpend: number;
  }>;
};
export type reviewPage_Query = {
  response: reviewPage_Query$data;
  variables: reviewPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categorizedTxnsCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTxnsCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "limit",
      "variableName": "limit"
    },
    {
      "kind": "Variable",
      "name": "offset",
      "variableName": "offset"
    }
  ],
  "concreteType": "PendingSuggestionsPayload",
  "kind": "LinkedField",
  "name": "pendingSuggestions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Suggestion",
      "kind": "LinkedField",
      "name": "suggestions",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pattern",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logic",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "confidence",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rationale",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "matchesCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalAmount",
          "storageKey": null
        },
        (v8/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalSpend",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "reviewPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategorizationCoverage",
        "kind": "LinkedField",
        "name": "categorizationCoverage",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v10/*: any*/),
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "UncategorizedStakeholder",
        "kind": "LinkedField",
        "name": "uncategorizedStakeholders",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "categories",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "reviewPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategorizationCoverage",
        "kind": "LinkedField",
        "name": "categorizationCoverage",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v10/*: any*/),
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "UncategorizedStakeholder",
        "kind": "LinkedField",
        "name": "uncategorizedStakeholders",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          (v12/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "categories",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b95cb8ed19a1023a8aad56e6e4febf3d",
    "id": null,
    "metadata": {},
    "name": "reviewPage_Query",
    "operationKind": "query",
    "text": "query reviewPage_Query(\n  $perspectiveId: ID\n  $limit: Int\n  $offset: Int\n) {\n  categorizationCoverage {\n    categorizedTxnsCount\n    totalTxnsCount\n    id\n  }\n  pendingSuggestions(limit: $limit, offset: $offset) {\n    totalCount\n    suggestions {\n      id\n      pattern\n      logic\n      origin\n      confidence\n      rationale\n      matchesCount\n      totalAmount\n      stakeholder {\n        id\n        name\n      }\n      category {\n        id\n        name\n      }\n    }\n  }\n  allStakeholders {\n    id\n    name\n  }\n  uncategorizedStakeholders(perspectiveId: $perspectiveId) {\n    stakeholder {\n      id\n      name\n    }\n    totalSpend\n    id\n  }\n  categories(perspectiveId: $perspectiveId) {\n    id\n    name\n    parent {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a553d568e82412638b6617d6c769dc8";

export default node;
